import { ApiError } from '@/lib/api.ts';

// Shared by every settings-page save mutation (HrSettings, ManagerSettings) —
// translates a PATCH /settings failure into user-facing copy.
export function translateSaveError(err: unknown): string {
  if (err instanceof ApiError) {
    if (err.status === 400) return 'Please check the highlighted fields and try again.';
    if (err.status === 403) return 'You do not have permission to update these settings.';
  }
  return 'Could not save changes. Try again.';
}
